import React from "react";
import { Link as RouterLink } from "react-router-dom";
import Button from "@civicplus/preamble-ui/lib/Button";
import VideocamIcon from "@material-ui/icons/Videocam";
import VideoStreamIcon from "mdi-material-ui/VideoWireless";
import { makeFullUrl } from "../../utils";

interface EventVideoButtonProps {
  eventId: number;
  externalMediaUrl?: string;
  isLive?: boolean;
  className?: string;
}

const EventVideoButton: React.FC<EventVideoButtonProps> = ({
  eventId,
  externalMediaUrl,
  isLive,
  className,
}) => {
  const renderedButtonProps: {
    href?: React.ComponentProps<typeof Button>["href"];
    openInNewWindow?: React.ComponentProps<typeof Button>["openInNewWindow"];
    component?: React.ComponentProps<typeof Button>["component"];
    to?: React.ComponentProps<typeof RouterLink>["to"];
  } = {};

  // If the component is embedded, use anchor element/href, else use RouterLink/to
  if (externalMediaUrl) {
    renderedButtonProps.href = externalMediaUrl;
    renderedButtonProps.openInNewWindow = true;
  } else if (process.env.REACT_APP_EMBED) {
    renderedButtonProps.href = makeFullUrl(`/event/${eventId}/media`);
    renderedButtonProps.openInNewWindow = true;
  } else {
    renderedButtonProps.component = RouterLink;
    renderedButtonProps.to = `event/${eventId}/media`;
  }

  return (
    <Button
      {...renderedButtonProps}
      type="icon"
      title={isLive ? "Go to Event Live Stream" : "Go To Event Media"}
      stopPropagation={true}
      onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation()}
      color="primary"
      className={className}
    >
      {isLive ? <VideoStreamIcon /> : <VideocamIcon />}
    </Button>
  );
};

export default EventVideoButton;
